import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, SortService, FilterService, GroupService, PageService,ResizeService, ReorderService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule}  from 'mydatepicker';
import { TimesheetverificationComponent } from './timesheetverification.component';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClientParentModule } from '../client-parent/client-parent.module';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimesheetverificationRoutingModule } from './timesheetverification-routing.module';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { EmployeeModule } from '../employee/employee.module';
@NgModule({
  declarations: [TimesheetverificationComponent],
  exports:[TimesheetverificationComponent],
  imports: [
    
    TimesheetverificationRoutingModule,
    CommonModule,
    GridModule,
    MyDatePickerModule,
    ReactiveFormsModule,
    ClientParentModule,
    FormsModule,
    DropDownListAllModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    EmployeeModule,
    dropdownModule,
  ],
  providers: [ColumnChooserService, SortService,
    ResizeService,
    FilterService,
    GroupService,PageService,ReorderService],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
     
})
export class TimesheetverificationModule { }
